import React, { useState } from 'react'
import { Button, Grid } from '@material-ui/core';

import Fade from 'react-reveal/Fade';

import ProjectCard from './ProjectCard/ProjectCard'

import './Projects.css'
import img1 from '../../assets/svg/img1.svg'
import img2 from '../../assets/svg/img2.svg'
import img3 from '../../assets/svg/img3.svg'
import img4 from '../../assets/svg/img4.svg'
import img5 from '../../assets/svg/img5.svg'
import img6 from '../../assets/svg/img6.svg'
import img7 from '../../assets/svg/img7.svg'
import img8 from '../../assets/svg/img8.svg'

import dialogImg1 from '../../assets/png/img1.png'
import dialogImg2 from '../../assets/png/img2.png'
import dialogImg3 from '../../assets/png/img3.png'
import dialogImg4 from '../../assets/png/img4.png'
import dialogImg5 from '../../assets/png/img5.png'
import dialogImg6 from '../../assets/png/img6.png'
import dialogImg7 from '../../assets/png/img7.png'
import dialogImg8 from '../../assets/png/img8.png'

const projects = [
    {
        id: 1,
        title: 'PinBook',
        description: 'Pinbook is the best image sharing social media app you can find right now on YouTube and throughout the entire internet. It has all the advanced social media features, including Google Authentication, create, edit, delete, and save posts, like and comment on other peoples posts, search and filter images, and much more.',
        img: img1,
        dialogImg: dialogImg1, 
        framework: 'REACT JS',
        technology: ['REACT JS', 'Tailwind CSS', 'Sanity'],
        github: 'https://github.com/MDDevelopers/PinBook',
        website: 'https://pinbook.netlify.app/'
    },
    {
        id: 2,
        title: 'Apply It - Jobs And Hiring',
        description: 'The existence of React Native makes React one of the most valuable skills to have. Learn how to transform 75% of your knowledge from making websites into building mobile applications today!',
        img: img2,
        dialogImg: dialogImg2, 
        framework: 'REACT NATIVE',
        technology: ['REACT NATIVE', 'CSS', 'JS', 'EXPO'],
        github: 'https://github.com/md-sabeel/applyit',
        // website: 'https://github.com/hhhrrrttt222111'
    },
    {
        id: 3,
        title: 'TravelApp',
        description: 'Travel App created using MERN stack!',
        img: img3,
        dialogImg: dialogImg3, 
        framework: 'MERN',
        technology: ['REACT', 'CSS', 'MONGO DB'],
        github: 'https://github.com/md-sabeel/TravelApp',
        // website: 'https://github.com/hhhrrrttt222111'
    },
    {
        id: 4,
        title: 'COVID-19 Tracker',
        description: 'COVID-19 Tracker made with ReactJS and Material-UI',
        img: img4,
        dialogImg: dialogImg4, 
        framework: 'REACT JS',
        technology: ['REACT', 'CSS'],
        github: 'https://github.com/md-sabeel/covid-tracker',
        website: 'https://covid-19-tracker-hrt.web.app/'
    },
    {
        id: 5,
        title: 'Dorkify',
        description: 'Perform Google Dork search with Dorkify',
        img: img5,
        dialogImg: dialogImg5, 
        framework: 'Python',
        technology: ['Python'],
        github: 'https://github.com/md-sabeel/Dorkify',
        // website: 'https://github.com/hhhrrrttt222111'
    },
    {
        id: 6,
        title: 'PyBox',
        description: 'PyBox provides you with a compilation of many such Python games, serving as a platform to, simply put, have fun. Ranging from pen and paper games like Tic Tac Toe to watered down and modified versions of popular classic arcade games like Snake, Flappy bird and Pong, we have a game for everybody to play.',
        img: img6,
        dialogImg: dialogImg6, 
        framework: 'HTML',
        technology: ['HTML', 'CSS', 'JS'],
        github: 'https://github.com/md-sabeel/PyBox',
        website: 'https://hhhrrrttt222111.github.io/PyBox/'
    },
    {
        id: 7,
        title: 'Etudia',
        description: 'ETUDIA is small platform that aims at making the studies of KTU 1st year students easy 📚 📋',
        img: img7,
        dialogImg: dialogImg7, 
        framework: 'HTML',
        technology: ['HTML', 'CSS', 'JS'],
        github: 'https://github.com/hhhrrrttt222111/etudia',
        website: 'https://hhhrrrttt222111.github.io/etudia/'
    },
    {
        id: 8,
        title: 'Trapple',
        description: 'Frontend of a Food Delivery website',
        img: img8,
        dialogImg: dialogImg8, 
        framework: 'HTML',
        technology: ['HTML', 'CSS'],
        github: 'https://github.com/hhhrrrttt222111/Trapple',
        website: 'https://hhhrrrttt222111.github.io/Trapple/'
    },
    
]





function Projects() {

    const total = projects.length
    const [cards, setCards] = useState(5)

    const handleLoad = () => {
        setCards(cards === 5 ? total : 5)
    }
    
    return (
        <div className="projects" id="projects">
            <h1>Projects</h1>
            <h4>My Works</h4>
            <Fade bottom>
                <Grid container direction="row" justify="center" alignItems="center" className="projects_container">
                    {projects.slice(0, cards).map(project => (
                        <ProjectCard 
                        img={project.img} 
                        title={project.title} 
                        description={project.description} 
                        framework={project.framework}
                        dialogImg={project.dialogImg}
                        technology={project.technology}
                        github={project.github}
                        website={project.website}
                        />
                    ))}
                </Grid>
            </Fade>
            {cards === 5 ? (
                <Button onClick={handleLoad}>
                    Show More
                </Button>
            ) : (
                <Button onClick={handleLoad}>
                    Show Less
                </Button>
            )}
        </div>
    )
}

export default Projects
